module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_path.js
// module id = 306
// module chunks = 0